import { t, type TranslatedString } from "@i18n";

export const fileViewModes = {
  DETAILED_VIEW: "DETAILED_VIEW",
  LARGE_ICONS_VIEW: "LARGE_ICONS_VIEW",
};
export const fileViewIconsMapper: Record<string, string> = {
  DETAILED_VIEW: "ListViewIcon",
  LARGE_ICONS_VIEW: "GridViewIcon",
};
export const fileViewOptions: { text: TranslatedString; id: string }[] = [
  { text: t("Details"), id: fileViewModes.DETAILED_VIEW },
  { text: t("Large Icons"), id: fileViewModes.LARGE_ICONS_VIEW },
];
